import { render } from "./tipsModal.vue?vue&type=template&id=52deb224&scoped=true"
import script from "./tipsModal.vue?vue&type=script&lang=js"
export * from "./tipsModal.vue?vue&type=script&lang=js"

import "./tipsModal.vue?vue&type=style&index=0&id=52deb224&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52deb224"]])

export default __exports__